import { render, staticRenderFns } from "./GoodsSellerRewardForm.vue?vue&type=template&id=51bf2744&scoped=true&"
import script from "./GoodsSellerRewardForm.vue?vue&type=script&lang=js&"
export * from "./GoodsSellerRewardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf2744",
  null
  
)

export default component.exports